import Route from '@ember/routing/route';

export default class KaderRoute extends Route {}
